import { Resources, AppPermissions } from '@erecruit/types';

import {
  CounterWidgetResource,
  PositionSearchCountRequestWithDataPref,
  ShiftSearchCountRequestWithDataPref,
  MatchSearchCountRequestWithDataPref,
} from '@erecruit/modules';

export const counterWidgets: CounterWidgetResource[] = [
  new CounterWidgetResource({
    widgetId: 'Counter.Positions.Open',
    searchType: 'Positions',
    searchTypeId: Resources.PositionSearchType.Open,
    text: messageIds.modules.widget.counterWidget.positionsText,
    iconColor: 'bodyTertiary',
    iconType: 'positions',
    color: 'statusStandard',
    searchRoute: `/positions?positionType=${nameof<
      Resources.PositionSearchType.Open
    >()}`,
    label: messageIds.modules.widget.counterWidget.openPositions,
    permission: AppPermissions.ViewPositions,
    resourceRequest: [
      new PositionSearchCountRequestWithDataPref({
        filter: {
          positionSearchType: Resources.PositionSearchType.Open,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Positions.Closed',
    searchType: 'Positions',
    searchTypeId: Resources.PositionSearchType.Closed,
    text: messageIds.modules.widget.counterWidget.positionsText,
    iconColor: 'bodyTertiary',
    searchRoute: `/positions?positionType=${nameof<
      Resources.PositionSearchType.Closed
    >()}`,
    iconType: 'closed-position',
    color: 'statusDisabled',
    label: messageIds.modules.widget.counterWidget.closedPositions,
    permission: AppPermissions.ViewPositions,
    resourceRequest: [
      new PositionSearchCountRequestWithDataPref({
        filter: {
          positionSearchType: Resources.PositionSearchType.Closed,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Positions.PendingMyApproval',
    searchType: 'Positions',
    searchTypeId: Resources.PositionSearchType.PendingMyApproval,
    text: messageIds.modules.widget.counterWidget.positionsText,
    iconColor: 'bodyTertiary',
    iconType: 'approvals',
    color: 'statusStandard',
    searchRoute: `/positions?positionType=${nameof<
      Resources.PositionSearchType.PendingMyApproval
    >()}`,
    label: messageIds.modules.widget.counterWidget.pendingMyApprovalPositions,
    permission: AppPermissions.ViewPositions,
    resourceRequest: [
      new PositionSearchCountRequestWithDataPref({
        filter: {
          positionSearchType: Resources.PositionSearchType.PendingMyApproval,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Matches.Submittals',
    searchType: 'Matches',
    searchTypeId: Resources.MatchSearchType.Submittals,
    text: messageIds.modules.widget.counterWidget.matchesText,
    iconColor: 'bodyTertiary',
    iconType: 'users',
    color: 'statusPending',
    searchRoute: `/matches?matchType=${nameof<
      Resources.MatchStatusType.Submittal
    >()}`,
    label: messageIds.modules.widget.counterWidget.submittedMatches,
    permission: AppPermissions.ViewMatches,
    resourceRequest: [
      new MatchSearchCountRequestWithDataPref({
        filter: {
          matchSearchType: Resources.MatchSearchType.Submittals,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Matches.Working',
    searchType: 'Matches',
    searchTypeId: Resources.MatchSearchType.Working,
    text: messageIds.modules.widget.counterWidget.matchesText,
    searchRoute: `/matches?matchType=${nameof<
      Resources.MatchStatusType.FullPlacement
    >()}`,
    iconColor: 'bodyTertiary',
    iconType: 'match',
    color: 'statusSuccess',
    label: messageIds.modules.widget.counterWidget.currentlyWorkingMatches,
    permission: AppPermissions.ViewMatches,
    resourceRequest: [
      new MatchSearchCountRequestWithDataPref({
        filter: {
          matchSearchType: Resources.MatchSearchType.Working,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Matches.PendingStart',
    searchType: 'Matches',
    searchTypeId: Resources.MatchSearchType.PendingStart,
    text: messageIds.modules.widget.counterWidget.matchesText,
    searchRoute: `/matches?matchType=${nameof<
      Resources.MatchSearchType.PendingStart
    >()}`,
    iconColor: 'bodyTertiary',
    iconType: 'check',
    color: 'statusSuccess',
    label: messageIds.modules.widget.counterWidget.pendingStartMatches,
    permission: AppPermissions.ViewMatches,
    resourceRequest: [
      new MatchSearchCountRequestWithDataPref({
        filter: {
          matchSearchType: Resources.MatchSearchType.PendingStart,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Matches.PendingMyApproval',
    searchType: 'Matches',
    searchTypeId: Resources.MatchSearchType.PendingMyApproval,
    text: messageIds.modules.widget.counterWidget.matchesText,
    searchRoute: `/matches?matchType=${nameof<
      Resources.MatchSearchType.PendingMyApproval
    >()}`,
    iconColor: 'bodyTertiary',
    iconType: 'approvals',
    color: 'statusPending',
    label: messageIds.modules.widget.counterWidget.pendingMyApprovalMatches,
    permission: AppPermissions.ViewMatches,
    resourceRequest: [
      new MatchSearchCountRequestWithDataPref({
        filter: {
          matchSearchType: Resources.MatchSearchType.PendingMyApproval,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Matches.EndingSoon',
    searchType: 'Matches',
    searchTypeId: Resources.MatchSearchType.EndingSoon,
    text: messageIds.modules.widget.counterWidget.matchesText,
    searchRoute: `/matches?matchType=${nameof<
      Resources.MatchSearchType.EndingSoon
    >()}`,
    iconColor: 'bodyTertiary',
    iconType: 'time',
    color: 'statusPending',
    label: messageIds.modules.widget.counterWidget.endingSoonMatches,
    permission: AppPermissions.ViewMatches,
    resourceRequest: [
      new MatchSearchCountRequestWithDataPref({
        filter: {
          matchSearchType: Resources.MatchSearchType.EndingSoon,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Shifts.Filled',
    searchType: 'Shifts',
    searchTypeId: Resources.ShiftSearchType.Filled,
    text: messageIds.modules.widget.counterWidget.shiftsText,
    iconColor: 'bodyTertiary',
    iconType: 'filled-shift',
    color: 'statusStandard',
    searchRoute: `/shifts?shiftType=${nameof<
      Resources.ShiftSearchType.Filled
    >()}`,
    label: messageIds.modules.widget.counterWidget.filledShifts,
    permission: AppPermissions.ViewShifts,
    resourceRequest: [
      new ShiftSearchCountRequestWithDataPref({
        filter: {
          shiftSearchType: Resources.ShiftSearchType.Filled,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Shifts.UnFilled',
    searchType: 'Shifts',
    searchTypeId: Resources.ShiftSearchType.UnFilled,
    text: messageIds.modules.widget.counterWidget.shiftsText,
    iconColor: 'bodyTertiary',
    iconType: 'calendar',
    color: 'statusPending',
    searchRoute: `/shifts?shiftType=${nameof<
      Resources.ShiftSearchType.UnFilled
    >()}`,
    label: messageIds.modules.widget.counterWidget.unfilledShifts,
    permission: AppPermissions.ViewShifts,
    resourceRequest: [
      new ShiftSearchCountRequestWithDataPref({
        filter: {
          shiftSearchType: Resources.ShiftSearchType.UnFilled,
        },
      }),
    ],
  }),
  new CounterWidgetResource({
    widgetId: 'Counter.Shifts.Cancelled',
    searchType: 'Shifts',
    searchTypeId: Resources.ShiftSearchType.Cancelled,
    text: messageIds.modules.widget.counterWidget.shiftsText,
    iconColor: 'bodyTertiary',
    iconType: 'cancelled-shift',
    color: 'statusCritical',
    searchRoute: `/shifts?shiftType=${nameof<
      Resources.ShiftSearchType.Cancelled
    >()}`,
    label: messageIds.modules.widget.counterWidget.cancelledShifts,
    permission: AppPermissions.ViewShifts,
    resourceRequest: [
      new ShiftSearchCountRequestWithDataPref({
        filter: {
          shiftSearchType: Resources.ShiftSearchType.Cancelled,
        },
      }),
    ],
  }),
];
